import React, { useEffect, useState } from 'react';
import { useAppContext } from 'providers/AppProvider';
import { Container, Row, Col, Form, Card, Badge, Button } from 'react-bootstrap';
import axios from 'axios';
import Select from "react-select";
import PatientCard from './PatientCard';
import ShimmerUI from 'components/ShimmerUI/PatientShimmer';
import CommonBreadCrumb from 'components/commonbreadcrumb/CommonBreadCrumb';
import { socket } from '../../socket';
import SetMastersDetails from 'components/common/SetMastersDetails';
import RemoveMasters from 'components/common/RemoveMasters';
import AddOrderDetailModal from './AddOrderDetailModal';
import ThemedSelect from 'components/commonbreadcrumb/ThemedSelect';
import TopSummaryBar from './TopSummaryBar';
import { storeList } from 'components/common/StoreList';

const PatientView = () => {
  const [storeOptions] = useState([{ key: "Select Store", value: "" }, ...storeList]);
  const [selectedStoreValue, setSelectedStoreValue] = useState('');
  const [cardData, setCardData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [topData, setTopData] = useState({});
  const [orderStatusToDate, setOrderStatusToDate] = useState('');
  const [orderStatusFromDate, setOrderStatusFromDate] = useState('');
  const [filteredCardData, setFilteredCardData] = useState(null);
  const [selectedFacility, setSelectedFacility] = useState({ key: 'ALL FACILITIES', value: '' });
  
  const [sortConfig, setSortConfig] = useState({
    column: null,
    direction: 'asc'
  });
  const [patientOptions, setPatientOptions] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [patientOptionsMaster, setPatientOptionsMaster] = useState([]);
  let results = JSON.parse(localStorage.getItem("facilitiesData"));
  const [options] = useState([
    { key: 'ALL FACILITIES', value: '' },
    ...results
  ]);

  const columnDefinitions = [
    { key: '2', title: 'Intake' },
    { key: '3', title: 'Data Entry' },
    { key: '4', title: 'PV1' },
    { key: '5', title: 'Filling' },
    { key: '6', title: 'PV2' },
    { key: '7', title: 'Manifest' },
  ];
  const computedColumns = columnDefinitions.map((column) => {
    let count = 0;
    if (filteredCardData && filteredCardData[column.key]) {
      Object.values(filteredCardData[column.key]).forEach((patient) => {
        if (patient.orders) {
          count += patient.orders.length;
        }
      });
    }
    return { ...column, count };
  });


  const {
    config: { isFluid, isNavbarVerticalCollapsed },
    setConfig
  } = useAppContext();

  const addOrderModal = () => {
    setShowModal(true);
  };


  const handleSort = (columnKey, direction) => {
    setSortConfig({
      column: columnKey,
      direction
    });
  };


  const sortPatients = (patients) => {
    return Object.keys(patients).sort((a, b) => {
      const dateA = getEarliestDeliveryDateForPatient(patients[a]);
      const dateB = getEarliestDeliveryDateForPatient(patients[b]);

      if (!dateA && !dateB) return 0;
      if (!dateA) return sortConfig.direction === 'asc' ? 1 : -1;
      if (!dateB) return sortConfig.direction === 'asc' ? -1 : 1;

      return sortConfig.direction === 'asc'
        ? dateA - dateB
        : dateB - dateA;
    });
  }

  useEffect(() => {
    setConfig('isFluid', true);
    setConfig('isNavbarVerticalCollapsed', true);

    async function onConnect() {
      console.log('Connected to server');
      await getPatientViewData();
    }

    function onDisconnect() {
      console.log('Disconnected from server');
    }

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);

    const tokenStr = localStorage.getItem("accessToken");
    socket.emit('getPatientViewData', { tokenStr });

    socket.on('patientDataUpdated', async () => {
      console.log('Patient data updated via socket.');
      await getPatientViewData();
    });

    getPatientViewData();
    SetMastersDetails();

    return () => {
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
      socket.emit('clearAllOrders', { tokenStr: tokenStr });
      setConfig('isFluid', false);
      setConfig('isNavbarVerticalCollapsed', false);
      RemoveMasters();
    };
  }, []);

  async function getPatientViewData() {
    let tokenStr = localStorage.getItem("accessToken");
    const { data } = await axios.get(`${process.env.REACT_APP_PHARMACY_SERVER_URL}/orders/patient-dashboard`, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
    const dataObj = data.orders;
    setTopData(data.orders_status_count);
    setOrderStatusToDate(data.orderCountStartDate)
    setOrderStatusFromDate(data.orderCountEndDate)
    setCardData(dataObj);
    let patientList = [];
    Object.keys(dataObj).forEach(statusKey => {
      Object.values(dataObj[statusKey]).forEach(patient => {
        patientList.push({
          key: `${patient.patient_lastname}, ${patient.patient_firstname}`,
          value: patient.patient_id,
          facility_id: patient.facility_id,
          lastname: patient.patient_lastname?.toLowerCase() || ''
        });
      });
    });
    patientList.sort((a, b) => a.lastname.localeCompare(b.lastname));
    const uniquePatients = Array.from(new Map(patientList.map(p => [p.value, p])).values());
    setPatientOptions(uniquePatients);
    setPatientOptionsMaster(uniquePatients);

    // let patientList = [];

    // Object.keys(dataObj).forEach(statusKey => {
    //   Object.values(dataObj[statusKey]).forEach(patient => {
    //     patientList.push({
    //       key: `${patient.patient_lastname}, ${patient.patient_firstname}`,
    //       value: patient.patient_id,
    //       facility_id: patient.facility_id
    //     });
    //   });
    // });
    // const uniquePatients = Array.from(new Map(patientList.map(p => [p.value, p])).values());
    // setPatientOptions(uniquePatients);
    // setPatientOptionsMaster(uniquePatients);
    setFilteredCardData(dataObj);
  }

  const handleStoreChange = (selectedOption) => {
    setSelectedStoreValue(selectedOption);
    setSelectedFacility({ key: 'ALL FACILITIES', value: '' });
    setSelectedPatient(null);
    if (selectedOption.value) {
      let filteredData = {};
      Object.keys(cardData).forEach((statusKey) => {
        let filteredPatients = Object.keys(cardData[statusKey])
          .filter(patientId => (cardData[statusKey][patientId].store_id || 1) === selectedOption.value)
          .reduce((obj, patientId) => {
            obj[patientId] = cardData[statusKey][patientId];
            return obj;
          }, {});

        if (Object.keys(filteredPatients).length > 0) {
          filteredData[statusKey] = filteredPatients;
        }
      });

      setFilteredCardData(filteredData);
    } else {
      setFilteredCardData(cardData);
    }
  }

  const handleFacilityFieldChange = (selectedOption) => {
    setSelectedFacility(selectedOption);
    setSelectedStoreValue('');
    setSelectedPatient(null);
    if (selectedOption.value) {
      let filteredData = {};
      Object.keys(cardData).forEach((statusKey) => {
        let filteredPatients = Object.keys(cardData[statusKey])
          .filter(patientId => cardData[statusKey][patientId].facility_id === selectedOption.value)
          .reduce((obj, patientId) => {
            obj[patientId] = cardData[statusKey][patientId];
            return obj;
          }, {});

        if (Object.keys(filteredPatients).length > 0) {
          filteredData[statusKey] = filteredPatients;
        }
      });

      setFilteredCardData(filteredData);
      const filteredPatients = patientOptionsMaster.filter(
        p => p.facility_id === selectedOption.value
      );
      setPatientOptions(filteredPatients);
    } else {
      // All facilities selected
      setFilteredCardData(cardData);
      setPatientOptions(patientOptionsMaster);  // restore full patient list
    }
  };

  const breadcrumbItems = [
    { name: 'Dashboard', href: '/main', isActive: false },
    { name: 'Patient', href: '#', isActive: true },
    { name: 'Patient Dashboard', href: "#", isActive: true }
  ];

  function getEarliestDeliveryDateForPatient(patient) {
    const dates = patient.orders
      .map(order => order.delivery_date)
      .filter(Boolean)
      .map(date => new Date(date));

    if (dates.length === 0) return null;
    return Math.min(...dates); // earliest timestamp
  }

  return (
    <>
      {cardData ? (
        <>
          <Row className="m-00">
            <AddOrderDetailModal show={showModal} setShow={setShowModal} />
            <CommonBreadCrumb breadcrumbItems={breadcrumbItems} />
            <Card className="p-1 pt-3 pb-1">
              <Row className="mb-3 align-items-center">
                <Col>
                  <TopSummaryBar stats={topData} orderStatusToDate={orderStatusToDate} orderStatusFromDate={orderStatusFromDate} />
                </Col>

                <Col className="d-flex flex-column justify-content-center">
                  <Form.Label className="mb-1 fw-semibold">Delivery Type</Form.Label>

                  <div className="d-flex align-items-center gap-4">
                    <div className="d-flex align-items-center gap-2">
                      <span
                        className="bg-red border rounded"
                        style={{
                          width: "20px",
                          height: "20px",
                          display: "inline-block",
                        }}
                      ></span>
                      <span className="fs-12 text-muted">Stat</span>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                      <span
                        className="bg-brown border rounded"
                        style={{
                          width: "20px",
                          height: "20px",
                          display: "inline-block",
                        }}
                      ></span>
                      <span className="fs-12 text-muted">Pickup</span>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <span
                        className="bg-orange border rounded"
                        style={{
                          width: "20px",
                          height: "20px",
                          display: "inline-block",
                        }}
                      ></span>
                      <span className="fs-12 text-muted">Others</span>
                    </div>
                  </div>
                </Col>
              </Row>
            </Card>
            <Card className="p-3 pt-3 pb-2 mb-4">
              <Row className='mb-3'>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Facility</Form.Label>
                    <ThemedSelect
                      name="facilityname"
                      closeMenuOnSelect={true}
                      placeholder='Select Facility'
                      classNamePrefix="react-select"
                      options={options}
                      value={selectedFacility}
                      getOptionLabel={option => option.key}
                      getOptionValue={option => option.value}
                      onChange={handleFacilityFieldChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Search Patient</Form.Label>
                    <ThemedSelect
                      name="patientsearch"
                      closeMenuOnSelect={true}
                      placeholder='Search Patient'
                      classNamePrefix="react-select"
                      options={patientOptions}
                      value={selectedPatient}
                      getOptionLabel={(option) => option.key}
                      getOptionValue={(option) => option.value}
                      onChange={(selected) => setSelectedPatient(selected)}
                      isClearable
                    />
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Store</Form.Label>
                    <ThemedSelect
                      name="store"
                      closeMenuOnSelect={true}
                      placeholder='Select store'
                      classNamePrefix="react-select"
                      options={storeOptions}
                      value={selectedStoreValue}
                      getOptionLabel={option => option.key}
                      getOptionValue={option => option.value}
                      onChange={(e) => handleStoreChange(e)}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          borderColor: "#ced4da",
                          boxShadow: "none",
                          "&:hover": { borderColor: "#80bdff" },
                        }),
                        option: (provided, { isFocused, isSelected }) => ({
                          ...provided,
                          backgroundColor: isSelected ? "#e9ecef !important" : isFocused ? "#f8f9fa !important" : "white !important",
                          color: isSelected ? "#212529 !important" : "#212529 !important",
                          cursor: "pointer",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          color: "#212529",
                        }),
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md={1} className='text-end mt-4'>
                  <Button onClick={addOrderModal} className='w-100 h-100'>Add Order</Button>
                </Col>
                <Col md={3} className="d-flex flex-column align-items-start">
                  <Form.Label>&nbsp;</Form.Label>
                  <div className="d-flex flex-wrap align-items-center gap-4 h-100">
                    <div className="d-flex align-items-center gap-2">
                      <span
                        className="bg-success border rounded"
                        style={{ width: '25px', height: '25px', display: 'inline-block' }}
                      ></span>
                      <span className="fs-11 text-muted">Internal Notes</span>
                    </div>
                    <div className="d-flex align-items-center gap-1">
                      <span
                        className="bg-info-dark border rounded"
                        style={{ width: '25px', height: '25px', display: 'inline-block' }}
                      />
                      <small className="text-muted">Messages</small>
                    </div>
                    <div className="d-flex align-items-center gap-1">
                      <span
                        className="border rounded"
                        style={{ width: '25px', height: '25px', display: 'inline-block', backgroundColor: '#f8f9fa' }}
                      />
                      <small className="text-muted">Call Back</small>
                    </div>
                  </div>
                </Col>
              </Row>
            </Card>
            {(() => {
              let finalData = filteredCardData;
              if (selectedPatient && selectedPatient.value) {
                let filtered = {};
                Object.keys(filteredCardData).forEach(statusKey => {
                  const patients = filteredCardData[statusKey];
                  const result = Object.keys(patients)
                    .filter(id => patients[id].patient_id === selectedPatient.value)
                    .reduce((obj, key) => {
                      obj[key] = patients[key];
                      return obj;
                    }, {});

                  if (Object.keys(result).length > 0) {
                    filtered[statusKey] = result;
                  }
                });
                finalData = filtered;
              }
              return Object.keys(finalData).length > 0 ? (
                computedColumns.map((column) => (
                  <Col key={column.key} id={column.key} xs={2} className="dayCols1 px-1">
                    <Card>
                      <Card.Header className="dateCol text-white card-header text-center p-2">
                        <div
                          className="d-flex justify-content-center align-items-center gap-1"
                          style={{ cursor: 'default' }}
                        >
                          <span>{column.title}</span>
                          <div
                            className="d-flex flex-column align-items-center ms-1"
                            style={{ lineHeight: '8px' }}
                          >
                            <span
                              style={{
                                fontSize: '10px',
                                cursor: 'pointer',
                                opacity:
                                  sortConfig.column === column.key && sortConfig.direction === 'asc'
                                    ? 1
                                    : 0.3
                              }}
                              onClick={e => {
                                e.stopPropagation();
                                handleSort(column.key, 'asc');
                              }}
                            >
                              ▲
                            </span>
                            <span
                              style={{
                                fontSize: '10px',
                                cursor: 'pointer',
                                opacity:
                                  sortConfig.column === column.key && sortConfig.direction === 'desc'
                                    ? 1
                                    : 0.3
                              }}
                              onClick={e => {
                                e.stopPropagation();
                                handleSort(column.key, 'desc');
                              }}
                            >
                              ▼
                            </span>
                          </div>
                          <Badge bg="success">{column.count}</Badge>
                        </div>
                      </Card.Header>
                      <Card.Body className='p-0'>
                        {finalData[column.key] &&
                          Object.keys(finalData[column.key])
                            .sort((a, b) => {
                              // Only sort when this column is active
                              if (sortConfig.column !== column.key) return 0;
                              const dateA = getEarliestDeliveryDateForPatient(finalData[column.key][a]);
                              const dateB = getEarliestDeliveryDateForPatient(finalData[column.key][b]);
                              if (!dateA && !dateB) return 0;
                              if (!dateA) return sortConfig.direction === 'asc' ? 1 : -1;
                              if (!dateB) return sortConfig.direction === 'asc' ? -1 : 1;

                              return sortConfig.direction === 'asc'
                                ? dateA - dateB
                                : dateB - dateA;
                            })
                            .map(patientId => {
                              const patient = filteredCardData[column.key][patientId];
                              return <PatientCard key={patientId} patient={patient} />;
                            })
                        }
                      </Card.Body>
                    </Card>
                  </Col>
                ))
              ) : (
                <div className="text-center py-4">
                  <h5 className="text-muted">No Data Available</h5>
                </div>
              );
            })()}
          </Row>
        </>
      ) : (
        <ShimmerUI />
      )}
    </>
  );
};

export default PatientView;